import { CommonModule } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { TegelModule } from '@scania/tegel-angular-17';
import { ModalComponent } from 'src/app/shared/components/modal/modal.component';
import { MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { MatCardModule } from '@angular/material/card';

interface CardItem {
  id: number;
  date: string,
  status: string,
  description: string;
}

@Component({
  selector: 'app-general',
  templateUrl: './general.component.html',
  styleUrls: ['./general.component.scss'],
  imports: [
    TegelModule,
    CommonModule,
    ModalComponent,
    MatPaginatorModule,
    MatCardModule
  ],
})
export class GeneralComponent implements OnInit {

  @ViewChild(ModalComponent) modalComponent!: ModalComponent;

  constructor() { }

  totalItems = 20;
  pageSize = 5;
  pagedItems: CardItem[] = [];
  showDetails = false

  mockData: CardItem[] = Array.from({ length: 20 }).map((_, i) => ({
    id: i + 1,
    date: '02/10/2024 16:10',
    status: 'DROP',
    description: `Descrição do item ${i + 1}`,
  }));

  ngOnInit() {
    this.setPage(0, this.pageSize);
  }

  openModal() {
    this.modalComponent.open();
  }

  setPage(pageIndex: number, pageSize: number) {
    const start = pageIndex * pageSize;
    const end = start + pageSize;
    this.pagedItems = this.mockData.slice(start, end);
  }

  onPageChange(event: PageEvent) {
    this.setPage(event.pageIndex, event.pageSize);
  }

  show() {
    this.showDetails = this.showDetails ? false : true;
  }
}